import {backButton} from "@telegram-apps/sdk"

const goBackRoute = async function () {
    const route = useState('backRoute', () => '/').value
    await navigateTo(route)

    if(route === '/') {
        backButton.hide.ifAvailable()
        backButton.offClick(goBackRoute)
    }
}

export default function (backRoute: string, withoutBackButton: boolean = false) {
    const route = useState('backRoute', () => '/')
    route.value = backRoute

    if(!withoutBackButton) {
        backButton.onClick(goBackRoute)
        backButton.show.ifAvailable()
    }
}